import { Observable } from 'rxjs';

export abstract class RecaptchaV3Adapter {
  abstract checkResponse(response: string): Observable<boolean>;
}
